export default __webpack_public_path__ + "static/media/0031d93fc5e7c24e2bc12f6d9ed2aca2.svg";